import React from 'react';

import { cn } from 'domain/core';
import { DivProps } from './common-types';

/**
 * Skeleton box component with a pulse animation
 * @param param0
 * @returns
 */
const Box = ({ className, ...props }: DivProps) => {
	return (
		<div
			className={cn(
				'box-skeleton',
				'h-8 w-full animate-pulse rounded bg-primary-400',
				className
			)}
			{...props}
		/>
	);
};

/**
 * Skeleton circle component with a pulse animation
 * @param param0
 * @returns
 */
const Circle = ({ className, ...props }: DivProps) => {
	return (
		<Box className={cn('circle-skeleton', 'h-8 w-8 rounded-full', className)} />
	);
};

export const Skeleton = {
	Box,
	Circle,
};
